var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-empty',{attrs:{"image":"error","description":"无访问权限"}}),_c('div',{staticStyle:{"text-align":"center"}},[_c('van-button',{attrs:{"type":"info"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }